module.exports = __webpack_public_path__ + "img/home@2x.fd51542c.png";